export default function startup() {
  // Verify is the user is logged
}